import Stage from "@frog/source/models/Stage.js"
import Selection from "@frog/source/models/admin/Selection.js"
import Audiomix from "@frog/source/juice/Audiomix.js"
// import Director from "@frog/source/juice/Director.js"
// import Geometry from "@frog/source/utility/Geometry.js"
// import App from "@frog/source/models/App.js"

export default class Chapter {
    static load({chapter, player, gameslug}) {
        chapter.phase = "explore"
        chapter.gameslug = gameslug

        if(chapter.audio != undefined) {
            if(chapter.audio instanceof Array) {
                chapter.audio.forEach((audio) => {
                    Audiomix.trigger(audio)
                })
            } else {
                Audiomix.trigger(chapter.audio)
            }
        }

        if(chapter.stage != undefined) {
            chapter.stage = Stage.load({
                "stage": chapter.stage,
                "player": player,
                // "chapterParty": proto.chapterParty,
                // "hasPreparePhase": chapter.hasPreparePhase,
            })
        }

        chapter.sequence = {}
        // if(chapter.sequence.steps != undefined
        // && chapter.sequence.steps.length > 0) {
        //     chapter.stage = chapter.sequence.steps[chapter.sequence.steps.length - 1].omegastage
        // }
        Chapter.triggerEvent(chapter, "chapter:start")

        chapter.selection = new Selection({"chapter": chapter})

        chapter.update = function(delta) {
            chapter.selection.update(delta)

            // if(Keyb.wasJustPressed("Z")) {
            //     Chapter.undoAction(chapter)
            // }
        }

        return chapter
    }

    static triggerEvent(chapter, eventkey) {
        if(chapter.stage != undefined
        && chapter.stage.events != undefined
        && chapter.stage.events[eventkey] != undefined) {
            Chapter.runEvents(chapter, chapter.stage.events[eventkey])
            return
        }
        if(chapter.stage != undefined
        && chapter.stage.encounters != undefined
        && chapter.stage.encounters[chapter.stage.currentEncounter || 1] != undefined
        && chapter.stage.encounters[chapter.stage.currentEncounter || 1].events != undefined
        && chapter.stage.encounters[chapter.stage.currentEncounter || 1].events[eventkey] != undefined) {
            Chapter.runEvents(chapter, chapter.stage.encounters[chapter.stage.currentEncounter || 1].events[eventkey])
        }
    }

    static runSteps(chapter, steps) {
        chapter.sequence = {"steps": steps}
    }
    static runEvents(chapter, events) {
        const steps = Stage.processEventSteps(chapter.stage, events)
        Chapter.runSteps(chapter, steps)
    }
}
